<div class="pricing-hub core-screen">
  <p class="pricing-hub__lead">{{ 'admin.pricing.hub.lead' | translate }}</p>

  @if (partialLoadError()) {
    <p class="hint hint--error" role="alert">
      {{ 'admin.pricing.hub.partialLoadError' | translate }}
    </p>
  }

  <section class="pricing-hub__domains">
    <h2 class="pricing-hub__section-title">
      {{ 'admin.pricing.hub.domainsTitle' | translate }}
    </h2>
    <div class="pricing-hub__cards">
      @for (domain of domains; track domain) {
        <a class="pricing-hub__card" [routerLink]="domainLink(domain)">
          <h3 class="pricing-hub__card-title">
            {{ 'admin.pricing.domains.' + domain + '.title' | translate }}
          </h3>
          <p class="pricing-hub__card-description">
            {{ 'admin.pricing.domains.' + domain + '.description' | translate }}
          </p>
          <span class="pricing-hub__card-count">
            @if (loading()) {
              —
            } @else {
              {{ domainCount(domain) }}
              {{ 'admin.pricing.hub.versionsCount' | translate }}
            }
          </span>
        </a>
      }
    </div>
  </section>

  @if (timelineSegments().length > 0) {
    <section class="pricing-hub__timeline">
      <h2 class="pricing-hub__section-title">
        {{ 'admin.pricing.hub.timelineTitle' | translate }}
      </h2>

      <div class="timeline-rail" aria-hidden="true">
        @for (segment of timelineSegments(); track segment.entry.version.id) {
          <div
            class="timeline-segment"
            [class.timeline-segment--current]="isCurrent(segment.entry.version)"
            [class.timeline-segment--future]="isFuture(segment.entry.version)"
          ></div>
        }
      </div>

      <div class="pricing-hub__timeline-list">
        @for (segment of timelineSegments(); track segment.entry.version.id) {
          <a
            class="version-card"
            [class.version-card--current]="isCurrent(segment.entry.version)"
            [class.version-card--future]="isFuture(segment.entry.version)"
            [routerLink]="
              versionLink(segment.entry.domain, segment.entry.version.id)
            "
          >
            <div class="version-card__header">
              <div class="version-badge">
                v{{ segment.entry.version.version_number }}
              </div>
              <div class="version-meta">
                <span class="domain-badge">
                  {{
                    'admin.pricing.domains.' + segment.entry.domain + '.badge'
                      | translate
                  }}
                </span>
                <div class="version-dates">
                  {{ 'admin.pricing.effectiveFrom' | translate }}:
                  {{ formatDate(segment.entry.version.effective_from) }}
                  @if (segment.entry.version.effective_to) {
                    <span class="separator">·</span>
                    {{ 'admin.pricing.effectiveTo' | translate }}:
                    {{ formatDate(segment.entry.version.effective_to) }}
                  } @else {
                    <span class="separator">·</span>
                    {{ 'admin.pricing.effectiveOpen' | translate }}
                  }
                </div>
                @if (segment.entry.domain === 'storage') {
                  <div class="version-rate">
                    {{ 'admin.pricing.baseRate' | translate }}:
                    {{
                      formatRate(
                        segment.entry.version.base_rate_bynd_per_m3_day
                      )
                    }}
                    {{ 'admin.pricing.rateUnit' | translate }}
                  </div>
                } @else if (segment.entry.domain === 'promocodes') {
                  <div class="version-rate">
                    {{ 'admin.pricing.promocodeCount' | translate }}:
                    {{ segment.entry.version.promocode_count ?? 0 }}
                  </div>
                }
                @if (segment.entry.version.comment) {
                  <div class="version-comment">
                    {{ segment.entry.version.comment }}
                  </div>
                }
              </div>
              <div class="version-status">
                @if (isFuture(segment.entry.version)) {
                  <span class="status-badge status-badge--future">
                    {{ 'admin.pricing.statusFuture' | translate }}
                  </span>
                } @else if (isCurrent(segment.entry.version)) {
                  <span class="status-badge status-badge--current">
                    {{ 'admin.pricing.statusCurrent' | translate }}
                  </span>
                }
              </div>
            </div>
          </a>
        }
      </div>
    </section>
  } @else if (loadError()) {
    <p class="hint hint--error" role="alert">
      {{ 'admin.pricing.loadError' | translate }}
    </p>
  } @else if (loading()) {
    <p class="hint" role="status">
      {{ 'admin.staffQrScan.loading' | translate }}
    </p>
  } @else {
    <p class="hint">{{ 'admin.pricing.hub.emptyTimeline' | translate }}</p>
  }
</div>
